import React from 'react';

import { Collapse, TableCell, TableRow, TextField } from '@material-ui/core';
import moment from 'moment';

import { IAdminEvent } from '../../../../store/admin/events/store';

import { ArrowDown } from '../../../../components/ArrowDown/ArrowDown';
import { ArrowUp } from '../../../../components/ArrowUp/ArrowUp';

interface IEventHistoryRow {
  collapsedRow: number | undefined;
  index: number;
  item: IAdminEvent;
  onClick: (index: number) => () => void;
  onExpandLess: () => void;
}

export const EventHistoryRow = (props: IEventHistoryRow) => {
  const { collapsedRow, index, item, onClick, onExpandLess } = props;

  return (
    <>
      <TableRow key={`tableRow-${index}`}>
        <TableCell>{moment(item.start).format('MM/DD/YYYY')}</TableCell>
        <TableCell align="center">{'-'}</TableCell>
        <TableCell align="left">{item.name}</TableCell>
        <TableCell align="center">{'-'}</TableCell>
        <TableCell align="center">{'-'}</TableCell>
        <TableCell align="center">{'-'}</TableCell>
        <TableCell align="center">{'-'}</TableCell>
        <TableCell align="center">{'-'}</TableCell>
        <TableCell align="center">
          {collapsedRow === index ? (
            <ArrowDown onClick={onExpandLess} />
          ) : (
            <ArrowUp onClick={onClick(index)} />
          )}
        </TableCell>
      </TableRow>

      <TableRow className="expandable-row" key={`hiddenTableRow-${index}`}>
        <TableCell className="inner-cell" colSpan={9}>
          <Collapse in={collapsedRow === index} timeout="auto" unmountOnExit={true}>
            {collapsedRow === index ? (
              <div className="event-earnings-container">
                <div className="earning-stats">
                  <p className="title">EARNINGS</p>
                  <div className="earning-row">
                    <div className="stats-values">
                      <p>POINTS</p>
                      <TextField
                        id="outlined-bare"
                        className="stats-text-field"
                        InputProps={{
                          classes: {
                            input: 'stats-text-field__input override'
                          }
                        }}
                        defaultValue={'-'}
                        margin="normal"
                        disabled={true}
                        variant="outlined"
                      />
                    </div>

                    <div className="stats-values">
                      <p>{`SCRIP`}</p>
                      <TextField
                        id="outlined-bare"
                        className="stats-text-field"
                        InputProps={{
                          classes: {
                            input: 'stats-text-field__input override'
                          }
                        }}
                        defaultValue={'-'}
                        margin="normal"
                        disabled={true}
                        variant="outlined"
                      />
                    </div>

                    <div className="stats-values">
                      <p>CASH</p>
                      <TextField
                        id="outlined-bare"
                        className="stats-text-field"
                        InputProps={{
                          classes: {
                            input: 'stats-text-field__input override'
                          }
                        }}
                        defaultValue={'-'}
                        margin="normal"
                        disabled={true}
                        variant="outlined"
                      />
                    </div>
                  </div>
                </div>
              </div>
            ) : null}
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
};
